<template>
  <div class="c-profile-view container">
    <ProfileViewTile class="mb-4" />
    <ProfileCards />
  </div>
</template>

<script>
import ProfileViewTile from "../components/rebuild/Profile/ProfileViewTile";
import ProfileCards from "../components/rebuild/Profile/ProfileCards";

import { Actions, Mutations } from "@/store/global/global.types.js";
import { mapGetters } from "vuex";

export default {
  name: "Profile",
  computed: {
    ...mapGetters(["getUser"])
  },
  components: {
    ProfileViewTile,
    ProfileCards
  },
  async mounted() {
    if (!this.getUser.id) {
      this.$store.commit(Mutations.SHOW_SPINNER);
      await this.$store.dispatch(Actions.GET_USER_PROFILE);
      await this.$store.dispatch("fetchUserPoints");
      this.$store.commit(Mutations.HIDE_SPINNER);
    }
  }
};
</script>

<style scoped>
.c-profile-view {
  padding: 20px 15px;
}
.overflow-hidden {
  overflow: hidden;
}
</style>
